import { createVNode as _createVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "pt-10" }
const _hoisted_2 = /*#__PURE__*/_createVNode("h1", {
  class: "anchor fw-bolder mb-5",
  id: "icons"
}, [
  /*#__PURE__*/_createVNode("a", { href: "#icons" }),
  /*#__PURE__*/_createTextVNode(" Icons ")
], -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "py-5" }, [
  /*#__PURE__*/_createTextVNode(" Use "),
  /*#__PURE__*/_createVNode("a", {
    href: "#",
    class: "fw-bold"
  }, "Duotone Svg Icons"),
  /*#__PURE__*/_createTextVNode(" in conbination with buttons as shown below: ")
], -1)
const _hoisted_4 = { class: "py-5" }
const _hoisted_5 = { class: "rounded border p-10" }
const _hoisted_6 = { class: "svg-icon svg-icon-2" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode("Caption ")
const _hoisted_8 = /*#__PURE__*/_createVNode("div", { class: "separator my-10" }, null, -1)
const _hoisted_9 = { class: "svg-icon svg-icon-2" }
const _hoisted_10 = { class: "pt-5 pb-20" }
const _hoisted_11 = /*#__PURE__*/_createVNode("div", { class: "py-5" }, [
  /*#__PURE__*/_createTextVNode(" Use "),
  /*#__PURE__*/_createVNode("a", {
    href: "#",
    class: "fw-bold"
  }, "Font Awesome Icons"),
  /*#__PURE__*/_createTextVNode(" in conbination with buttons as shown below: ")
], -1)
const _hoisted_12 = { class: "py-5" }
const _hoisted_13 = { class: "rounded border p-10" }
const _hoisted_14 = /*#__PURE__*/_createVNode("i", { class: "fas fa-envelope-open-text fs-4 me-2" }, null, -1)
const _hoisted_15 = /*#__PURE__*/_createTextVNode(" Caption ")
const _hoisted_16 = /*#__PURE__*/_createVNode("div", { class: "separator my-10" }, null, -1)
const _hoisted_17 = /*#__PURE__*/_createVNode("i", { class: "fas fa-envelope-open-text fs-4" }, null, -1)
const _hoisted_18 = { class: "pt-5 pb-20" }
const _hoisted_19 = /*#__PURE__*/_createTextVNode(/*#__PURE__*/_toDisplayString(`<a href="#" class="btn btn-primary"
          ><i class="fas fa-envelope-open-text fs-4 me-2"></i> Caption</a
        >
        <a href="#" class="btn btn-success"
          ><i class="fas fa-envelope-open-text fs-4 me-2"></i> Caption</a
        >
        <a href="#" class="btn btn-info"
          ><i class="fas fa-envelope-open-text fs-4 me-2"></i> Caption</a
        >
        <a href="#" class="btn btn-warning"
          ><i class="fas fa-envelope-open-text fs-4 me-2"></i> Caption</a
        >
        <a href="#" class="btn btn-danger"
          ><i class="fas fa-envelope-open-text fs-4 me-2"></i> Caption</a
        >
        <a href="#" class="btn btn-dark"
          ><i class="fas fa-envelope-open-text fs-4 me-2"></i> Caption</a
        >

        <a href="#" class="btn btn-icon btn-primary"
          ><i class="fas fa-envelope-open-text fs-4 me-2"></i
        ></a>
        <a href="#" class="btn btn-icon btn-success"
          ><i class="fas fa-envelope-open-text fs-4 me-2"></i
        ></a>
        <a href="#" class="btn btn-icon btn-info"
          ><i class="fas fa-envelope-open-text fs-4 me-2"></i
        ></a>
        <a href="#" class="btn btn-icon btn-warning"
          ><i class="fas fa-envelope-open-text fs-4 me-2"></i
        ></a>
        <a href="#" class="btn btn-icon btn-danger"
          ><i class="fas fa-envelope-open-text fs-4 me-2"></i
        ></a>
        <a href="#" class="btn btn-icon btn-dark"
          ><i class="fas fa-envelope-open-text fs-4 me-2"></i></a
        >`))
const _hoisted_20 = /*#__PURE__*/_createVNode("div", { class: "py-5" }, [
  /*#__PURE__*/_createTextVNode(" Use "),
  /*#__PURE__*/_createVNode("a", {
    href: "#",
    class: "fw-bold"
  }, "Line Awesome Icons"),
  /*#__PURE__*/_createTextVNode(" in conbination with buttons as shown below: ")
], -1)
const _hoisted_21 = { class: "py-5" }
const _hoisted_22 = { class: "rounded border p-10" }
const _hoisted_23 = /*#__PURE__*/_createVNode("i", { class: "las la-wallet fs-2" }, null, -1)
const _hoisted_24 = /*#__PURE__*/_createTextVNode(" Caption ")
const _hoisted_25 = /*#__PURE__*/_createVNode("div", { class: "separator my-10" }, null, -1)
const _hoisted_26 = /*#__PURE__*/_createVNode("i", { class: "las la-wallet fs-2" }, null, -1)
const _hoisted_27 = { class: "py-5" }
const _hoisted_28 = /*#__PURE__*/_createTextVNode(/*#__PURE__*/_toDisplayString(`<a href="#" class="btn btn-icon btn-primary"
          ><i class="las la-wallet fs-2 me-2"></i> Caption</a
        >
        <a href="#" class="btn btn-icon btn-success"
          ><i class="las la-wallet fs-2 me-2"></i> Caption</a
        >
        <a href="#" class="btn btn-icon btn-info"
          ><i class="las la-wallet fs-2 me-2"></i> Caption</a
        >
        <a href="#" class="btn btn-icon btn-warning"
          ><i class="las la-wallet fs-2 me-2"></i> Caption</a
        >
        <a href="#" class="btn btn-icon btn-danger"
          ><i class="las la-wallet fs-2 me-2"></i> Caption</a
        >
        <a href="#" class="btn btn-icon btn-dark"
          ><i class="las la-wallet fs-2 me-2"></i> Caption</a
        >

        <a href="#" class="btn btn-icon btn-primary"
          ><i class="las la-wallet fs-2 me-2"></i
        ></a>
        <a href="#" class="btn btn-icon btn-success"
          ><i class="las la-wallet fs-3 me-2"></i
        ></a>
        <a href="#" class="btn btn-icon btn-info"
          ><i class="las la-wallet fs-3 me-2"></i
        ></a>
        <a href="#" class="btn btn-icon btn-warning"
          ><i class="las la-wallet fs-3 me-2"></i
        ></a>
        <a href="#" class="btn btn-icon btn-danger"
          ><i class="las la-wallet fs-3 me-2"></i
        ></a>
        <a href="#" class="btn btn-icon btn-dark"
          ><i class="las la-wallet fs-3 me-2"></i></a
        >`))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")
  const _component_CodeHighlighter = _resolveComponent("CodeHighlighter")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createVNode("div", _hoisted_4, [
      _createVNode("div", _hoisted_5, [
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.colors, (item, i) => {
          return (_openBlock(), _createBlock("a", {
            key: i,
            href: "#",
            class: [`btn-${item}`, "btn me-2 mb-2"]
          }, [
            _createVNode("span", _hoisted_6, [
              _createVNode(_component_inline_svg, { src: "media/icons/duotone/Shopping/Chart-bar3.svg" })
            ]),
            _hoisted_7
          ], 2))
        }), 128)),
        _hoisted_8,
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.colors, (item, i) => {
          return (_openBlock(), _createBlock("a", {
            key: i,
            href: "#",
            class: [`btn-${item}`, "btn btn-icon me-2 mb-2"]
          }, [
            _createVNode("span", _hoisted_9, [
              _createVNode(_component_inline_svg, { src: "media/icons/duotone/Shopping/Chart-bar3.svg" })
            ])
          ], 2))
        }), 128))
      ])
    ]),
    _createVNode("div", _hoisted_10, [
      _createVNode(_component_CodeHighlighter, { lang: "html" }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(`<a href="#" class="btn btn-primary"
          ><span class="svg-icon svg-icon-2"><svg>...</svg></span>Caption</a
        >
        <a href="#" class="btn btn-success"
          ><span class="svg-icon svg-icon-2"><svg>...</svg></span>Caption</a
        >
        <a href="#" class="btn btn-info"
          ><span class="svg-icon svg-icon-2"><svg>...</svg></span>Caption</a
        >
        <a href="#" class="btn btn-warning"
          ><span class="svg-icon svg-icon-2"><svg>...</svg></span>Caption</a
        >
        <a href="#" class="btn btn-danger"
          ><span class="svg-icon svg-icon-2"><svg>...</svg></span>Caption</a
        >
        <a href="#" class="btn btn-dark"
          ><span class="svg-icon svg-icon-2"><svg>...</svg></span>Caption</a
        >

        <a href="#" class="btn btn-icon btn-primary"
          ><span class="svg-icon svg-icon-2"><svg>...</svg></span></a
        >
        <a href="#" class="btn btn-icon btn-success"
          ><span class="svg-icon svg-icon-2"><svg>...</svg></span></a
        >
        <a href="#" class="btn btn-icon btn-info"
          ><span class="svg-icon svg-icon-2"><svg>...</svg></span></a
        >
        <a href="#" class="btn btn-icon btn-warning"
          ><span class="svg-icon svg-icon-2"><svg>...</svg></span></a
        >
        <a href="#" class="btn btn-icon btn-danger"
          ><span class="svg-icon svg-icon-2"><svg>...</svg></span></a
        >
        <a href="#" class="btn btn-icon btn-dark"
          ><span class="svg-icon svg-icon-2"><svg>...</svg></span></a
        >`), 1)
        ]),
        _: 1
      })
    ]),
    _hoisted_11,
    _createVNode("div", _hoisted_12, [
      _createVNode("div", _hoisted_13, [
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.colors, (item, i) => {
          return (_openBlock(), _createBlock("a", {
            key: i,
            href: "#",
            class: [`btn-${item}`, "btn me-2 mb-2"]
          }, [
            _hoisted_14,
            _hoisted_15
          ], 2))
        }), 128)),
        _hoisted_16,
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.colors, (item, i) => {
          return (_openBlock(), _createBlock("a", {
            key: i,
            href: "#",
            class: [`btn-${item}`, "btn btn-icon me-2 mb-2"]
          }, [
            _hoisted_17
          ], 2))
        }), 128))
      ])
    ]),
    _createVNode("div", _hoisted_18, [
      _createVNode(_component_CodeHighlighter, { lang: "html" }, {
        default: _withCtx(() => [
          _hoisted_19
        ]),
        _: 1
      })
    ]),
    _hoisted_20,
    _createVNode("div", _hoisted_21, [
      _createVNode("div", _hoisted_22, [
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.colors, (item, i) => {
          return (_openBlock(), _createBlock("a", {
            key: i,
            href: "#",
            class: [`btn-${item}`, "btn me-2 mb-2"]
          }, [
            _hoisted_23,
            _hoisted_24
          ], 2))
        }), 128)),
        _hoisted_25,
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.colors, (item, i) => {
          return (_openBlock(), _createBlock("a", {
            key: i,
            href: "#",
            class: [`btn-${item}`, "btn btn-icon me-2 mb-2"]
          }, [
            _hoisted_26
          ], 2))
        }), 128))
      ])
    ]),
    _createVNode("div", _hoisted_27, [
      _createVNode(_component_CodeHighlighter, { lang: "html" }, {
        default: _withCtx(() => [
          _hoisted_28
        ]),
        _: 1
      })
    ])
  ]))
}